import React, { useState } from 'react';
import SharepointModal from '../SharepointModal';
import useSharepoint from '../../hooks/useSharepoint';
import styles from './sharepoint-panel.module.scss';
import Button from '@/components/Button';
import SharepointIcon from '@/assets/icons/sharepoint.svg?react';

type Props = {
  orgID?: string;
  orgIndex?: number;
};

const SharepointPanel = ({ orgID, orgIndex }: Props) => {
  const [modalTopic, setModalTopic] = useState<
    'instructions' | 'settings' | null
  >(null);
  const {
    summary,
    syncRuns,
    health,
    folders,
    isFetchingSummary,
    isFetchingSyncs,
    isFetchingHealth,
    isConnected,
    triggerSync,
    isSyncInProgress,
  } = useSharepoint(orgID, orgIndex);

  const handleClick = () => {
    if (isConnected) {
      setModalTopic('settings');
    } else {
      setModalTopic('instructions');
    }
  };

  return (
    <div className={styles['sharepoint-panel']}>
      <Button
        variation="secondary"
        className={styles['sharepoint-cta']}
        data-status={isConnected ? 'connected' : 'disconnected'}
        onClick={handleClick}
        loading={isFetchingSummary || isFetchingSyncs || isFetchingHealth}
        loadingText="Checking connection"
      >
        <SharepointIcon />
        {isConnected ? 'Sharepoint Settings' : 'Connect to SharePoint'}
      </Button>

      {modalTopic !== null && folders && (
        <SharepointModal
          isOpen={modalTopic !== null}
          onClose={() => setModalTopic(null)}
          topic={modalTopic}
          folders={folders}
          summary={summary}
          syncRuns={syncRuns}
          health={health}
          isLoading={isFetchingSummary || isFetchingSyncs}
          onSync={() => triggerSync()}
          isSyncing={isSyncInProgress}
        />
      )}
    </div>
  );
};

export default SharepointPanel;
